// POST /api/v1/notifications/read — mark specific ids (or all, with no
// ids) read, then refresh the bell.

import { useMutation, useQueryClient } from "@tanstack/react-query";

import { attachRequestIdToScope } from "../../lib/api-client";

type MarkReadInput = {
  /** Omit to mark ALL unread notifications read. */
  ids?: string[];
};

async function markNotificationsRead(input: MarkReadInput): Promise<void> {
  const response = await fetch("/api/v1/notifications/read", {
    method: "POST",
    credentials: "include",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(input.ids ? { ids: input.ids } : {}),
  });
  attachRequestIdToScope(response);
  if (!response.ok) {
    throw new Error(`Mark-read failed (HTTP ${response.status})`);
  }
}

export function useMarkNotificationsRead() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: markNotificationsRead,
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["notifications"] });
    },
    // Silent on error — a failed mark-read self-heals on the next poll;
    // toasting would be noise for a background bookkeeping action.
  });
}
